import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';

import { parkHubJoinKey } from '../utils/hub-join-park';

/**
 * `/hubs/join/<token>`: park the token for this tab and go on to `to`
 * (`/hubs`, or `/preview/hubs` in the harness) without it.
 *
 * A guard returning a UrlTree rather than a redirectTo, because a redirect
 * keeps no hook in which to take the token out first. The page it lands on
 * reads the parked key (core/utils/hub-join-park.ts).
 */
export function hubJoinGuard(to: '/hubs' | '/preview/hubs'): CanActivateFn {
  return route => {
    const token = route.paramMap.get('token');
    if (token) parkHubJoinKey({ token });
    return inject(Router).createUrlTree([to]);
  };
}
